/**
 * function that converts string to lower case
 * @param str - string to be converted
 */

// str : string | null | undefined will give build error
 export const toLowerCase = (str: string) => {
	try {
	//str = str + '';  -- it  will convert undefined to 'undefined' and null to 'null'
	return str?.toLowerCase();
	} catch (e) {
		console.log(`Error in toLowerCase,converting ${str} to lower case`);
		return "";
	}
};

export const toLowerCaseWithOptionalParam = (str?: string) => {
	try {
	//str = str + '';  -- it  will convert undefined to 'undefined' and null to 'null'
	return str?.toLowerCase();
	} catch (e) {
		console.log(`Error in toLowerCase,converting ${str} to lower case`);
		return "";
	}
};
